export const globals = {
    points: 0
};
